import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PageHeadline, TextTitle } from '../../components/atoms';
import { OnboardingHeader } from '../../components/OnboardingHeader';
import { randomInt } from '../../utils/random';

const PaymentSuccededScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const randomImage = useMemo(() => randomInt(1, 5), []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-50 lg:flex">
      <div className="w-full lg:w-4/5">
        <div className="mx-auto max-w-7xl px-6 py-8 lg:px-12">
          <OnboardingHeader />

          <div className="mt-6">
            <PageHeadline
              title={t('others.othPaymentSuccess')}
              className="mt-8 shadow-xl"
              gradientFrom="from-primary"
              gradientTo="to-blue-800"
            />
          </div>

          <div className="mt-8 flex justify-center">
            <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-sm ring-1 ring-slate-900/5 text-center">
              <TextTitle>{t('others.othPaymentSuccess')}</TextTitle>

              <div className="mt-6 flex w-full justify-center">
                <button
                  className="h-[40px] w-full md:w-[200px] bg-[#0C1FAA] text-white rounded hover:bg-[#0e1a73] text-sm"
                  onClick={() => navigate('/dashboard')}
                >
                  {t('buttons.btnGoToDashboard')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hidden lg:block lg:w-1/5">
        <div className="relative h-screen">
          <img src={`/img/image0${randomImage}.png`} className="h-full w-full object-cover" alt="" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent" />
          <p className="absolute bottom-[25%] left-6 right-6 text-[32px] font-bold leading-tight text-white">
            {t('labels.lblWeveHelped')}
          </p>
        </div>
      </div>
    </div>
  );
};

export { PaymentSuccededScreen };
